import { createFileRoute, redirect } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { ENABLE_REGISTER } from "@/configs";
import { RegisterPage } from "@/modules/auth";

export const Route = createFileRoute("/auth/register")({
  component: () => (
    <>
      <DocumentTitle
        title="Register"
        description="Create a new LAMPU Seller Center account."
      />
      <RegisterPage />
    </>
  ),
  beforeLoad: ({ context }) => {
    if (!ENABLE_REGISTER) {
      throw redirect({
        to: "/auth/login"
      });
    }

    if (context.auth.isAuthenticated) {
      throw redirect({
        to: "/"
      });
    }
  }
});
